import * as React from 'react'
import { Typography } from '@mui/material'


export default function retailerColumn() {
    return [{
		name: 'seller', label: 'Seller',
		options: {
			display: 'excluded',
		}
	},{
        name: 'seller', label: 'Seller',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => <Typography>{value}</Typography>
        }
    }]
}